import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './Master.css';

const CourtMaster = () => {
  const { courts, setCourts, addAuditLog } = useApp();
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    courtName: '',
    courtType: 'District Court',
    jurisdiction: '',
    address: '',
    contactNumber: '',
    email: '',
    courtrooms: [],
  });
  const [editingId, setEditingId] = useState(null);

  const courtTypes = ['Supreme Court', 'High Court', 'District Court', 'Session Court', 'Magistrate Court'];

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (editingId) {
      // Update existing court
      setCourts(courts.map(court => 
        court.id === editingId 
          ? { ...court, ...formData }
          : court
      ));
      addAuditLog('Court Updated', `Court ${formData.courtName} updated`);
    } else {
      // Add new court
      const newCourt = {
        id: Date.now().toString(),
        ...formData,
        createdAt: new Date().toISOString(),
      };
      setCourts([...courts, newCourt]);
      addAuditLog('Court Added', `New court ${formData.courtName} added`);
    }
    
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      courtName: '',
      courtType: 'District Court',
      jurisdiction: '',
      address: '',
      contactNumber: '',
      email: '',
      courtrooms: [],
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleEdit = (court) => {
    setFormData(court);
    setEditingId(court.id);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    const court = courts.find(c => c.id === id);
    setCourts(courts.filter(c => c.id !== id));
    addAuditLog('Court Deleted', `Court ${court.courtName} deleted`);
  };

  return (
    <div className="master-container">
      <div className="master-header">
        <h1>📂 Court Master</h1>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary">
          {showForm ? 'Cancel' : '+ Add Court'}
        </button>
      </div>

      {showForm && (
        <div className="master-form-card">
          <h2>{editingId ? 'Edit Court' : 'Add New Court'}</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="form-group">
                <label>Court Name *</label>
                <input
                  type="text"
                  value={formData.courtName}
                  onChange={(e) => setFormData({...formData, courtName: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Court Type *</label>
                <select
                  value={formData.courtType}
                  onChange={(e) => setFormData({...formData, courtType: e.target.value})}
                  required
                >
                  {courtTypes.map(type => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Jurisdiction *</label>
                <input
                  type="text"
                  value={formData.jurisdiction}
                  onChange={(e) => setFormData({...formData, jurisdiction: e.target.value})}
                  required
                />
              </div>

              <div className="form-group">
                <label>Address *</label>
                <textarea
                  value={formData.address}
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                  required
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Contact Number</label>
                <input
                  type="tel"
                  value={formData.contactNumber}
                  onChange={(e) => setFormData({...formData, contactNumber: e.target.value})}
                />
              </div>

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary">
                {editingId ? 'Update' : 'Add'} Court
              </button>
              <button type="button" onClick={resetForm} className="btn-secondary">
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="master-table-card">
        <h2>Court List ({courts.length})</h2>
        {courts.length > 0 ? (
          <div className="table-container">
            <table className="master-table">
              <thead>
                <tr>
                  <th>Court Name</th>
                  <th>Type</th>
                  <th>Jurisdiction</th>
                  <th>Address</th>
                  <th>Contact</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {courts.map(court => (
                  <tr key={court.id}>
                    <td><strong>{court.courtName}</strong></td>
                    <td>{court.courtType}</td>
                    <td>{court.jurisdiction}</td>
                    <td>{court.address}</td>
                    <td>{court.contactNumber || 'N/A'}</td>
                    <td>
                      <button onClick={() => handleEdit(court)} className="btn-edit">Edit</button>
                      <button onClick={() => handleDelete(court.id)} className="btn-delete">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="empty-state">No courts added yet. Click "Add Court" to get started.</p>
        )}
      </div>
    </div>
  );
};

export default CourtMaster;

